module.exports = __webpack_public_path__ + "static/media/UniversityofArizona.ac01700d.png";